import { stringToElements } from '../helpers/index.js';
import { getOpenWalletLink } from '../pricing/links.js';

// Insert the My Wallet Widget
export const insertHeaderWallet = (API, isMobile, iconConfig) => {
    API.insert('header-toolbar', async (elem) => {
        // get icon type from config
        const iconClass = iconConfig.length > 0 ? iconConfig[0] : 'mywallet';
        if (isMobile) {
            const walletIconTemplate = `
            <i class="ddc-icon-${iconClass} ddc-icon ddc-nav-icon" aria-hidden="true" title="myWallet" role="presentation" tabindex="-1"></i>
            `;
            const walletIconEle = await stringToElements(walletIconTemplate);
            const openMobileWalletLink = getOpenWalletLink(
                null, 
                'btn btn-default ddc-btn-nav btn-no-decoration btn-unstyled border-0 w-100', 
                false, 
                false, 
                null, 
                'budget'
            );
            openMobileWalletLink.appendChild(walletIconEle);
            API.append(elem, openMobileWalletLink);
            
            // update style, add ddc-btn-nav class for header-toolbar
            const headerToolbarEle = elem.parentElement;
            if (headerToolbarEle) {
                headerToolbarEle.classList.add('ddc-btn-nav');
            }
        }
        else {
            const desktopHeaderTemplate = `
            <div class="show-true toolbar-open toolbar-white  ddc-toolbar logged-out">
                <div class="toolbar-flex">
                    <div class="mycars has-digital-retailing mycars-integration-navbar border-left-0">
                        <div class="size-360-auto menu menu-show float-left wallet-link">
                        </div>
                    </div>
                </div>
            </div>
            `;
            const markup = await stringToElements(desktopHeaderTemplate);
            const openDesktopWalletLink = getOpenWalletLink(null, `ddc-icon-${iconClass} ddc-icon ddc-nav-icon`, false, false, null, 'budget');
            markup.querySelector('.wallet-link').append(openDesktopWalletLink);
            // For some specific case for Toyota, this OEM will add another icon on header-toolbar location
            elem.append(markup);
            elem.parentElement.prepend(elem);
        }
    });
}
